var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartOptions.series[0].data[0].name != '')?_c('div',{attrs:{"id":"test2","options":_vm.chartOptions},on:{"click":_vm.onClickBuble}}):_c('div',{attrs:{"id":"test2","options":_vm.chartOptions},on:{"click":_vm.onClickBuble}})
}
var staticRenderFns = []

export { render, staticRenderFns }